"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWeb3Eth = void 0;
const contracts_helper_1 = require("@teleportdao/contracts-helper");
function getWeb3Eth(targetNetworkConnectionInfo) {
    let baseEth;
    if (targetNetworkConnectionInfo.web3Eth) {
        baseEth = new contracts_helper_1.EthereumBase({
            web3Eth: targetNetworkConnectionInfo.web3Eth,
        });
    }
    else if (targetNetworkConnectionInfo.provider) {
        baseEth = new contracts_helper_1.EthereumBase({});
        baseEth.setWeb3EthProvider(targetNetworkConnectionInfo.provider);
    }
    else if (targetNetworkConnectionInfo.web3) {
        baseEth = new contracts_helper_1.EthereumBase({
            connectionInfo: targetNetworkConnectionInfo.web3,
        });
    }
    if (!baseEth)
        throw new Error("web3 is undefined");
    const connectionConfig = {
        web3Eth: baseEth.web3Eth,
    };
    return { baseEth, connectionConfig };
}
exports.getWeb3Eth = getWeb3Eth;
//# sourceMappingURL=helper.js.map